<template>
  <div class="user-modal-body">
    <h3 class="text-center mb-4"
        v-if="!localId">{{$t('message.overview.message.updateAllBoxes')}}</h3>
    <h3 class="text-center mb-4"
        v-if="localId">{{ localName }}</h3>

    <div v-for="(option, index) in loginOptions"
         :key="index"
         class="flex-center mb-1">
      <template v-if="localId">
        <app-toggle v-model="option.isActive"
                    :disabled="!option.isAllowed"></app-toggle>
        <span class="option-label"
              :class="`ml-2 ${option.isAllowed ? '' : 'option-label_disabled'}`">{{ option.label }}</span>
        <span v-if="!option.isAllowed">{{$t('message.overview.message.temporarilyInactive')}}</span>
      </template>
      <template v-else>
        <app-toggle v-model="option.isAllowed"></app-toggle>
        <span class="ml-2">{{ option.label }}</span>
      </template>
    </div>

    <div class="card-footer">
      <div class="footer flex-center mt-2">
        <button class="btn btn-primary btn-round"
                @click="submit()">
          {{$t('message.generics.message.save')}}
        </button>
      </div>
    </div>

  </div>
</template>

<script>
    import AppToggle from '@components/Toggle'
    import EventBus from '@packages/event-bus'

    export default {
        components: {
            AppToggle
        },

        data() {
            return {
              userId: undefined,
              loginOptions: [],
              localName: '',
              localId: null,
              loginFacebook: false,
              loginFormulario: false,
              loginGoogle: false
            }
        },


        methods: {
            async reset(data = {}) {
              this.localId = data.id;
              this.localName = data.name;
              this.userId = data.userId;

              const possibleLoginOptions = await this.$api.locals.getPossibleLogins({ id: data.id, userId: data.userId });

              this.loginOptions = possibleLoginOptions;


            },

            async submit() {
                const possibleLogins = [];

                this.loginOptions.forEach((option) => {
                  if(this.localId) {
                    if(option.isActive) {
                      possibleLogins.push(option.name);
                    }
                  } else {

                    if(option.isAllowed) {
                      possibleLogins.push(option.name);
                    }
                  }
                })

                try {
                  const response = await this.$api.locals.alterLoginTypes({
                    id: this.localId,
                    userId: this.userId,
                    possibleLogins
                  })

                  EventBus.$emit('show-message', {
                      type: 'SUCCESS',
                      message: response.message,
                      timeout: 3000,
                  })
                  EventBus.$emit('LOAD_DEVICES')
                  EventBus.$emit('RESET_UPDATE_LOGIN_TYPES')
                } catch (error) {
                  console.log(error);
                }
            },

        },


        mounted() {
            EventBus.$on('RESET_BODY_LOGIN_TYPES_BODY', this.reset)
        },

        beforeDestroy() {
            EventBus.$off('RESET_BODY_LOGIN_TYPES_BODY', this.reset)
        },

    }
</script>

<style lang="scss" scoped>
.user-modal-body {
  padding: 30px 50px;

  .flex {
    justify-content: space-between;
  }

  .select-description {
    padding-top: 6px;
    width: 100px;
  }
  .dropdown {
    width: calc(100% - 100px) !important;
  }

  .option-label {
    &.option-label_disabled {
      color: #b3b3b3;
    }
  }
}
</style>
